import { z } from "zod";
export const SCIM_PATCH_OP_URN = "urn:ietf:params:scim:api:messages:2.0:PatchOp";
const BaseOp = z.object({
    op: z.string().transform((s) => s.toLowerCase()),
    path: z.string().optional(),
    value: z.any().optional(),
});
const OperationSchema = BaseOp.superRefine((data, ctx) => {
    const op = data.op;
    const hasValue = data.value !== undefined;
    const hasPath = data.path !== undefined;
    switch (op) {
        case "add":
        case "replace":
            if (!hasValue) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ["value"],
                    message: `"value" is required when op is "${op}"`,
                });
            }
            break;
        case "remove":
            if (!hasPath) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ["path"],
                    message: `"path" is required when op is "remove"`,
                });
            }
            if (hasValue) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ["value"],
                    message: `"value" must NOT be present when op is "remove"`,
                });
            }
            break;
        default:
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ["op"],
                message: `op must be "add", "replace", or "remove" (got "${op}")`,
            });
    }
});
export const DTOScimPatchPayload = z.object({
    schemas: z
        .array(z.string())
        .min(1)
        .refine((arr) => arr.includes(SCIM_PATCH_OP_URN), {
        message: `schemas array must include "${SCIM_PATCH_OP_URN}"`,
    }),
    Operations: z.array(OperationSchema).min(1),
});
